//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OrderOriginal",
  data() {
    return {
      originalFileList: [],
    };
  },
  props: {
    type: {
      type: Number, //附件类型 2 合同原件 3订单原件 4结算凭证
    },
    bizId: {
      type: String,
    },
  },
  mounted() {
    this.getOriginalFileList();
  },
  computed: {
    filePreviewList() {
      let tempAry = [];
      this.originalFileList.forEach((item) => {
        tempAry.push(item.picPath);
      });
      return tempAry;
    },
  },
  methods: {
    /**
     * @descripttion: 获取原件数据
     * @Author: juanjuanhui
     * @Date: 2022-05-19 10:46:38
     */
    getOriginalFileList() {
      let { type, bizId } = this;
      this.$http.common.getContractFileList({ type, bizId }).then((res) => {
        this.originalFileList = res.data;
      });
    },
  },
};
